module.exports = __webpack_public_path__ + "img/iconfont.d1b0ae6f.svg";